import pick from "lodash/pick";
import routeMixin from "./route.mixin";

export default {
  mixins: [routeMixin],
  data() {
    return {
      order: {
        by: this.$route.query.order_by,
        direction: this.$route.query.order_direction
      },
      // order_by: null,
      pagination: {
        page: this.$route.query.page || 1,
        per_page: 25,
        data: null,
        first_page_url: null,
        from: null,
        last_page: null,
        last_page_url: null,
        next_page_url: null,
        path: null,
        prev_page_url: null,
        to: null,
        total: null
      }
    };
  },
  mounted() {
    this.$route
  },
  methods: {
    setPage(page) {
      this.pagination.page = page;
      this._updateQuery();
    },
    _setOrderBy(orderBy) {
      const ascending = "asc";
      const descending = "desc";

      if (this.order.by == orderBy && this.order.direction == ascending) {
        this.order = {
          by: null,
          direction: null
        };
      } else {
        this.order.direction =
          this.order.direction == descending && orderBy == this.order.by
            ? ascending
            : descending;
        this.order.by = orderBy;
      }

      this._updateQuery();

      this.onOrderBy(orderBy);
    },
    _updateQuery() {
      const queryData = this._getPaginationQuery();
      if (JSON.stringify(this.$route.query) == JSON.stringify(queryData))
        return;

      this._saveQuery(queryData);
      this.$router.push({ query: queryData });
    },
    _getPaginationQuery() {
      const data = { page: this.pagination.page };

      if (this.order.by) {
        data.order_by = this.order.by;
        data.order_direction = this.order.direction;
      }

      return data;
    },
    _onPageClick() {
      this.setPage(this.pagination.page);
      this.onPage();
    },
    onPage() {
      // Override in child cmp
    },
    onOrderBy() {
      // Override in child cmp
    },
    getPaginationPostData() {
      return {
        page: parseInt(this.pagination.page),
        per_page: parseInt(this.pagination.per_page),
        // ...pick(this.pagination, ["page", "per_page"]),
        ...(this.order.by
          ? { order_by: this.order.by, order_direction: this.order.direction }
          : {})
      };
    }
  }
};
